import { SecureFieldProps } from '@msc-b2c/interfaces/types';
import { handleKeyDown } from '@msc-b2c/shared-utils/keyboardUtils';

export default function SecureField({
  fieldType,
  label,
  customClass,
  callback,
  children,
  amountType,
}: Readonly<SecureFieldProps>) {
  const handleClick = () => {
    if (callback) {
      callback();
    }
  };

  const cleanLabel = label ? label.replace(/[^a-zA-Z ]/g, '') : '';

  return (
    <div
      id={fieldType + '-number-container-' + amountType}
      className={customClass}
      onClick={handleClick}
      onKeyDown={(event) => handleKeyDown(event, handleClick)}
    >
      <label htmlFor={fieldType + '-number-' + amountType}>{label}</label>
      <div className="secure-field--input-container">
        <div
          className="secure-field--input"
          id={fieldType + '-number-' + amountType}
          aria-label={cleanLabel}
        ></div>
        <div className="secure-field--actions">
          <span className={'secure-field--action secure-field--action__' + fieldType + '-icon'}>
            <span className={'secure-field--action-' + fieldType + '-wrap'}>{children}</span>
          </span>
        </div>
      </div>
    </div>
  );
}
